import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import DetailOfRent from "./DetailOfRent";
import rahel from "../../../img/rahel1.jpg";
import "./rent.css";
import _ from "lodash";

const TableScrolePrint = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { IT_table, IT_joripara,
            IT_Note } =
            value;
          let arr = [];
          for (let i = IT_table.length; i > 0; i--) {
            const el = IT_table[i - 1];
            if (el) {
              arr = [...arr, el];
            }
          }
          const dataRentPrint = arr.map((user, i) => {
            return (
              <tr
                key={i}
                className="f4"
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black"
                }}
              >
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {IT_joripara == "دۆلار" ? (
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.kodolar))
                          ? Number(user.kodolar)
                          : Number(user.kodolar).toFixed(2)
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  ) : (
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.kodinar))
                          ? Number(user.kodinar)
                          : Number(user.kodinar).toFixed(2)
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  )}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {
                    <NumberFormat
                      value={user.nrx}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  }
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >

                  {Number.isInteger(Number(user.dana))
                    ? Number(user.dana)
                    : Number(user.dana).toFixed(2)}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {Number.isInteger(Number(user.darzan))
                    ? Number(user.darzan)
                    : Number(user.darzan).toFixed(2)}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {Number.isInteger(Number(user.carton))
                    ? Number(user.carton)
                    : Number(user.carton).toFixed(4)}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {user.nawisht}
                </td>
                <td
                  style={{
                    borderBottom: "2px solid black",
                    borderTop: "2px solid black",
                    borderRight: "2px solid black",
                    borderLeft: "2px solid black",
                    fontSize: "1.3em",
                    color: "black",
                    padding: "10px 0px"
                  }}
                  className="fk"
                >
                  {user.raqam}
                </td>
              </tr>
            );
          });

          return (
            <>
              <table
                id="example"
                className="tc black-90 py-3 f2-l fk"
                media="print"
              >
                <thead>
                  <tr
                    className="text-dark f4"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black"
                    }}
                  >
                    <th colSpan="8">
                      <img src={rahel} alt="rahel" />
                      <DetailOfRent />
                    </th>
                  </tr>

                  <tr
                    className="text-black-50 f4 fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black"
                    }}
                  >
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      کۆی گشتی
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      نرخ
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      دانە
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      دەرزن
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      کارتۆن
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      ناوی شتەکان
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        color: "black",
                        backgroundColor: "gray",
                        padding: "15px 0px"
                      }}
                    >
                      کۆد
                    </th>
                  </tr>
                </thead>
                <tbody
                  media="printe"
                  style={{ borderBottom: "1px solid black" }}
                >
                  {dataRentPrint}
                </tbody>
                <tfoot>
                  <tr className="text-black" >
                    {/* <th>2</th> */}
                    <th colSpan="4" className="f4" style={{ backgroundColor: "white" }}>
                      {" "}
                      {!IT_Note ? "تێبینی : گۆڕین و گەڕانەوەی کاڵا نیە" : IT_Note}
                    </th>
                    <th
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        backgroundColor: "white"
                      }}
                      className="f4"
                    >
                      {Number(_.sumBy(IT_table, "carton")).toFixed(4)}
                    </th>
                    <th colSpan="2" className="f4" style={{ backgroundColor: "white" }}>

                    </th>
                  </tr>
                </tfoot>
              </table>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default TableScrolePrint;
